import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { MessengerEmailComponent } from './messenger.email.component';
import { MessengerService }        from './messenger.service';
import { MessengerSmsComponent }   from './messenger.sms.component';
import { SharedModule }            from '../../shared/shared.module';

@NgModule({
  declarations: [
    MessengerEmailComponent,
    MessengerSmsComponent
  ],
  entryComponents: [
    MessengerEmailComponent,
    MessengerSmsComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    MessengerService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class MessengerModule {}
